import RunConfigService from './runConfigService.js';
import UrlService from './urlService.js';
import axios from 'axios';

async function addAssesment(user, products) {
    let data;
    let response = [];
    const headers = {
        'client_id': RunConfigService.getRunConfig().clientId,
        'Authorization': `JWT ${user.eid}`
    };
    const url = `${UrlService.getAwsUrl()}/ns-share-api/v1/connect/user/${user.id}/agelocme`;
    if (products.length > 0) {
        for (let i = 0; i < products.length; i++) {
            if(products[i].agelocme){
                data = products[i].agelocme
                let agelocMeData = await axios({url, method: 'POST', data, headers });
                response.push(agelocMeData.body);
            }
        }
    }
    return response;

}

async function addAssesmentLegacy(user, products) {
    let data;
    let response = [];
    const headers = {
        'client_id': RunConfigService.getRunConfig().clientId,
        'Authorization': `JWT ${user.eid}`
    };
    const url = `${UrlService.getAwsUrl()}/ns-share-api/v0/connect/user/${user.id}/agelocme`;
    if (products.length > 0) {
        for (let i = 0; i < products.length; i++) {
            if(products[i].agelocme){
                data = products[i].agelocme
                let agelocMeData = await axios({url, method: 'POST', data, headers });
                response.push(agelocMeData.body);
            }
        }
    }
    return response;

}

async function getAssessments (user) {
    const headers = {
        'client_id': RunConfigService.getRunConfig().clientId
    };
    const response = await axios({
        url: `${UrlService.getAwsUrl()}/ns-share-api/v1/connect/user/${user.id}/agelocme`,
        method: 'GET',
        headers
    });

    return response.body;
}

async function getAssessmentsLegacy (user) {
    const headers = {
        'client_id': RunConfigService.getRunConfig().clientId
    };
    const response = await axios({
        url: `${UrlService.getAwsUrl()}/ns-share-api/v0/connect/user/${user.id}/agelocme`,
        method: 'GET',
        headers
    });

    return response.body;
}

async function getAssessment (user, assessmentId) {
    const headers = {
        'client_id': RunConfigService.getRunConfig().clientId
    };
    const response = await axios({
        url: `${UrlService.getAwsUrl()}/ns-share-api/v1/connect/user/${user.id}/agelocme/${assessmentId}`,
        method: 'GET',
        headers
    });

    return response.body;
}

export default {
    addAssesment: addAssesment,
    addAssesmentLegacy: addAssesmentLegacy,
    getAssessments: getAssessments,
    getAssessment: getAssessment,
    getAssessmentsLegacy: getAssessmentsLegacy
}
